export default __webpack_public_path__ + "static/media/image-not-found.b2910526.jpg";